import { useState } from 'react'
import { motion } from 'framer-motion'
import { slideIn } from '../utils/variants';
import '../styles/Contact.css';
function Contact() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData()
        formData.append('entry.2005620554', name); 
        formData.append('entry.1045781291', email); 
        formData.append('entry.839337160', message);

        fetch('https://docs.google.com/forms/d/e/1FAIpQLSed2CTa5FK51I1z0Q13F0ioo0najjyYYld3vAan6RnxlmXoAw/formResponse', {
            method: 'POST',
            mode: 'no-cors',
            body: formData,
        })
        .then(() => {
            alert('Form submitted successfully!');
            setName('');
            setEmail('');
            setMessage('');
        })
        .catch((error) => {
            console.error('Error submitting form:', error);
        });
    };

    return (
        <div id='contact-section' className="contact-container">
            <motion.div
             variants={slideIn("left", 0.2)}
                    initial="hidden"
                    whileInView={"show"}
                viewport={{ once: false, amount: 0.1 }}
            className="contact-message">
            <h1>Contact</h1>
            <p>I would love to hear about your project and how I could help. Please fill in the form, and I’ll get back to you as soon as possible.</p>
            </motion.div>

            {/* <div contact-form>
                <iframe
                    src="https://docs.google.com/forms/d/e/1FAIpQLSed2CTa5FK51I1z0Q13F0ioo0najjyYYld3vAan6RnxlmXoAw/viewform?embedded=true"
                    width="500"
                    height="500"
                    frameborder="0"
                    marginheight="0"
                    marginwidth="0"
                    title='Contact Form'>
                    Loading…</iframe>
            </div> */}

            <div className='contact-form'>
            <motion.div
                variants={slideIn("right", 0.1)}
                initial="hidden"
                whileInView={"show"}
                viewport={{ once: false, amount: 0.1 }}>
            <form onSubmit={handleSubmit}>
                <label htmlFor="name">Name</label>
                <input
                    type="text"
                    id="name"
                        value={name}
                        placeholder='NAME'
                    onChange={(e) => setName(e.target.value)}
                />

                <label htmlFor="email">Email</label>
                <input
                    type="email"
                    id="email"
                        value={email}
                        placeholder='EMAIL'
                    onChange={(e) => setEmail(e.target.value)}
                />

                <label htmlFor="message">Message</label>
                <textarea
                    id="message"
                        value={message}
                        placeholder='MESSAGE'
                    onChange={(e) => setMessage(e.target.value)}
                />

                    <button type="submit">   
                        SEND MESSAGE
                 
                    </button>
                    </form>
                    </motion.div>
            </div> 
        </div>

    );
}

export default Contact;